class TransferDomains {
  submitButton = document.querySelector('.js-transfer-submit')
  priceLabel = document.querySelector('.js-transfer-cost')
  domainToggles = document.querySelectorAll('.js-transfer-toggle')
  initialPriceMessage = this.priceLabel.innerHTML
  costPerDomain = null
  startingBill = 0
  trialActive = false

  constructor() {
    this.costPerDomain = parseFloat(
      this.priceLabel.getAttribute('data-price-per-domain')
    )
    this.startingBill = parseFloat(
      this.priceLabel.getAttribute('data-starting-bill')
    )
    this.trialActive = this.priceLabel.getAttribute('data-trial-active')
    this.submitButton.setAttribute('disabled', true)

    this.domainToggles.forEach(toggle => {
      toggle.addEventListener('change', () => {
        this.updatePrice()
      })
    })
  }

  updatePrice() {
    const selectedDomains = [].slice
      .call(this.domainToggles)
      .filter(toggle => toggle.checked).length
    const totalCost = selectedDomains * this.costPerDomain + this.startingBill
    let costMessage = this.initialPriceMessage

    if (selectedDomains > 0) {
      const pluralized = selectedDomains === 1 ? 'domain' : 'domains'
      costMessage =
        'Transferring ' +
        selectedDomains +
        ' ' +
        pluralized +
        ' will <strong class="u-semibold">increase your monthly bill to $' +
        totalCost +
        '</strong>' +
        (this.trialActive === 'true' ? ' (once your trial ends)' : '') +
        '.'
      this.submitButton.removeAttribute('disabled')
    } else {
      this.submitButton.setAttribute('disabled', true)
    }

    this.submitButton.value =
      selectedDomains === 1 ? 'Transfer domain' : 'Transfer domains'

    this.priceLabel.innerHTML = costMessage
  }
}

document.addEventListener('turbolinks:load', function () {
  if (document.querySelector('.js-transfer-toggle')) {
    new TransferDomains()
  }
})
